import { observer } from 'mobx-react-lite';

import { useStores } from '../hooks/use-stores';

function YieldModals() {
  const { modalsStore } = useStores();
  return modalsStore.state.currentModal;
}

export default observer(YieldModals);
